import { HttpClient } from '@angular/common/http';
import { ComponentFactoryResolver, Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import {map} from 'rxjs/operators'
import { environment } from 'src/environments/environment';
import { ForgotPasswordDto } from '../_models/forgotpassworddto';
import { Profile } from '../_models/profile';
import { ResetPasswordDto } from '../_models/resetpassworddto';
import { User } from '../_models/user';
import { JwtHelperService } from "@auth0/angular-jwt";

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  baseUrl = environment.apiUrl;
  private currentUserSource = new ReplaySubject<User>(1);
  currentUser$ = this.currentUserSource.asObservable();

  private currentTempUserSource = new ReplaySubject<User>(1);
  currentTempUser$ = this.currentTempUserSource.asObservable();

  private currentIsloggedInSource = new ReplaySubject<boolean>(1);
  isLoggedIn$ = this.currentIsloggedInSource.asObservable();

  constructor(private http: HttpClient) { }

  templogin(model: any)
  {
    return this.http.post(this.baseUrl + 'customer/login', model).pipe(
      map((response: User) => {
        const user = response;
        if (user){
          this.setTempCurrentUser(user);
        }
      })
    )
  }

  forgotPassword(model: ForgotPasswordDto)
  {
    return this.http.post(this.baseUrl + 'customer/forgotpassword', model);
  }

  resetPassword(body: ResetPasswordDto) {
    return this.http.post(this.baseUrl + 'customer/resetpassword', body);
  }

  login(model: any)
  {
    return this.http.post(this.baseUrl + 'customer/login', model).pipe(
      map((response: User) => {
        //console.log(response);
        const user = response;
        if (user){
          this.setCurrentUser(user);
        }
      })
    )
  }

  getProfile()
  {
    return this.http.get<Profile>(this.baseUrl + 'customer/profile').pipe(
      map((response: Profile) => {
        return response;        
      })
    )
  }

  updateProfile(profile: Profile){
    return this.http.put(this.baseUrl + 'customer/profile', profile).pipe(
      map(() => {

      })
    );
  }

  setTempCurrentUser(user: User){

    localStorage.setItem('tempuser', JSON.stringify(user));
    this.currentTempUserSource.next(user);
  }

  setCurrentUser(user: User){
    if (user == null)
      return;
      localStorage.removeItem('tempuser');
    user.roles = [];
    const roles = this.getDecodedToken(user.token).role;

    Array.isArray(roles) ? user.roles = roles : user.roles.push(roles);
    localStorage.setItem('user', JSON.stringify(user));
    this.currentUserSource.next(user);
    this.currentIsloggedInSource.next(true);
  }

  logout()
  {
    localStorage.removeItem('user');
    this.currentUserSource.next(null);
    this.currentIsloggedInSource.next(false);
  }

  register(model: any)
  {
    return this.http.post(this.baseUrl + 'customer/register', model).pipe(
      map((user : User) => {
        if (user){
          this.setTempCurrentUser(user);
        }
        return user;
      })
    )
  }

  getDecodedToken(token){
    return JSON.parse(atob(token.split('.')[1]));
  }

  isTokenExpired() : boolean {
    let currentuser : User; 
    this.currentUser$.subscribe(user => currentuser = user).unsubscribe();
    if (currentuser == null)
    {
      this.currentIsloggedInSource.next(false);
      return true;
    }
    
    const helper = new JwtHelperService();
    //console.log(currentuser.token);
    const isexpired = helper.isTokenExpired(currentuser.token);
    //console.log("Is token expired "+ isexpired);
    //console.log("token expiration date" + helper.getTokenExpirationDate(currentuser.token));
    this.currentIsloggedInSource.next(!isexpired);

    return isexpired;
  }

}
